export enum MobileProvider {    
    AllTel = 1,
    Att = 2,
    BellMobility = 3,
    FidoMicrocell = 4,
    MetroPcs = 5,
    Nextel = 6,
    Rogers = 7,
    SprintPcs = 8,
    SureWest = 9,
    Telus = 10,
    TMobile = 11,
    UsCellular = 12,
    Verizon = 13,
    VirginMobileCanada = 14,
    VirginMobileUs = 15
}